export default "__VITE_ASSET__BigT3wDl__"